var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vimeo-player',{ref:"player",staticClass:"vimeo-player",attrs:{"options":_vm.options,"video-id":_vm.videoId},on:{"fullscreenchange":_vm.onFullScreenChange,"seeked":_vm.onPlay,"play":_vm.onPlay,"pause":_vm.onPause,"ended":_vm.onEnded}})}
var staticRenderFns = []

export { render, staticRenderFns }